module.exports = __webpack_public_path__ + "assets/today-kz.f2d90276.svg";